namespace Matrix.Data {
    export class SecurityMergeColumns {
        static columnsKey = 'Data.SecurityMerge';
    }
}
